import { render, staticRenderFns } from "./PublicTermsOfService.vue?vue&type=template&id=de6d3a9a&scoped=true&"
import script from "./PublicTermsOfService.vue?vue&type=script&lang=js&"
export * from "./PublicTermsOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6d3a9a",
  null
  
)

export default component.exports